import {
  currentSharepointFolderState,
  currentSharepointFolderUserPermissions,
} from "../../../src/taskpane/redux/models/reduxModels";

export interface FolderPermissionMenuState {
  shouldRender: boolean;
  isDisabled: boolean;
  shouldGuardAction: boolean;
}

export const getFolderPermissionMenuState = ({
  currentSharepointFolder,
  requiredPermissions,
}: {
  currentSharepointFolder?: currentSharepointFolderState;
  requiredPermissions: Array<keyof currentSharepointFolderUserPermissions>;
}): FolderPermissionMenuState => {
  const permissionStatus = currentSharepointFolder?.permissionStatus;

  if (permissionStatus === "loaded") {
    const hasRequiredPermissions = requiredPermissions.every(permission =>
      currentSharepointFolder?.userPermissions?.[permission] === true
    );

    return {
      shouldRender: hasRequiredPermissions,
      isDisabled: !hasRequiredPermissions,
      shouldGuardAction: !hasRequiredPermissions,
    };
  }

  if (permissionStatus === "loading" || permissionStatus === "unknown") {
    return {
      shouldRender: true,
      isDisabled: false,
      shouldGuardAction: true,
    };
  }

  return {
    shouldRender: false,
    isDisabled: true,
    shouldGuardAction: true,
  };
};

export const runFolderPermissionMenuAction = (
  folderPermissionMenuState: FolderPermissionMenuState,
  action: () => void
): void => {
  if (folderPermissionMenuState.shouldGuardAction) {
    return;
  }

  action();
};
